import { useFunnelBackgroundPreload } from '../hooks/useFunnelBackgroundPreload';

/** Невидимый компонент — запускает фоновый preload воронки в layout. */
export function FunnelBackgroundWarmup() {
    useFunnelBackgroundPreload();
    return null;
}
